/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ProviderSubscriptionRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.providerSubscriptions', {
            url: '/providerSubscriptions',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'providerSubscription.providerSubscriptions'
            },
            ncyBreadcrumb: {
                label: '{"icon": "subscriptions", "label": "providerSubscription.providerSubscriptions"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, providerSubscriptionTableConfig) {
                        return providerSubscriptionTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/provider/subscription/provider-subscription.routes.js